const CellUnits = {
    Day: 0,
    Hour: 1,
};

export default CellUnits;
